import {Button, Flex, Image, Input, InputProps, SaveIcon, Text} from "@fluentui/react-northstar";
import ConfigureListImage from "../../../../assets/configure_list.svg";
import languageObject from "../../../../translations";
import React, {useCallback, useContext, useEffect} from "react";
import {MailingList} from "../../../../Interfaces/MailingList";
import {AppContext, IAppContextState} from "../../../../services/AppContext";

type State = {
    name: string,
    isSaving: boolean,
}

type Props = {
    users: Array<string>,
    onSaved: () => void,
}

const initialState: State = {
    name: "",
    isSaving: false,
}

export const ConfigureList = (props: Props) => {
    const context = useContext<IAppContextState>(AppContext);
    const [state, setState] = React.useState<State>({...initialState});

    useEffect(() => {
        setState({...initialState});
    }, [props.users]);

    const handleChangeName = useCallback((_: React.SyntheticEvent | undefined, data: InputProps | undefined) => {
        const value = (data?.value ?? "") + "";
        setState(prevState => ({...prevState, name: value}));
    }, []);

    const handleSave = useCallback((name: string) => async () => {
        setState(prevState => ({...prevState, isSaving: true}));
        const list: MailingList = {id: "", tenantId: context.teams.tenantId, name, emails: props.users};
        await context.usersLists.addUpdateUsersList(list);
        props.onSaved();
    }, [props.onSaved]);

    const usersLength = props.users.length;

    const isSaveButtonDisabled = state.name.length < 3 || state.isSaving;

    return (
        <Flex fill column hAlign={"center"} vAlign={"center"} gap={"gap.small"}>
            <Image fluid src={ConfigureListImage} styles={{height: "250px", minHeight: "250px", objectFit: "contain"}}/>
            <Flex fill column hAlign={"center"} gap={"gap.large"}>
                <Flex fill column hAlign={"center"} gap={"gap.medium"}>
                    <Flex column hAlign={"center"} styles={{gap: "5px"}}>
                        <Text
                            size={"large"} weight={"bold"}
                            content={languageObject.translate(usersLength <= 1 ? "OneUserImportedWithSuccess" : "CountUsersImportedWithSuccess", {count: usersLength})}
                        />
                        <Text content={languageObject.translate("GiveANameToYourMailingList")}/>
                    </Flex>
                    <Flex styles={{width: "320px"}}>
                        <Input
                            fluid
                            value={state.name}
                            onChange={handleChangeName}
                            maxLength={50}
                            placeholder={languageObject.translate("EnterListName")}
                            disabled={state.isSaving}
                        />
                    </Flex>
                </Flex>
                <Flex className={"w-100"} hAlign={"end"}>
                    <Button
                        primary content={languageObject.translate("Save")}
                        icon={<SaveIcon outline size={"large"}/>}
                        disabled={isSaveButtonDisabled}
                        loading={state.isSaving}
                        onClick={handleSave(state.name)}
                    />
                </Flex>
            </Flex>
        </Flex>
    )
}